import {
  colorMatch,
  tagMatch,
  statusMatch,
  playTypeMatch,
  ageGroupMatch,
} from './matches';

export const utils = {
  colorMatch,
  tagMatch,
  statusMatch,
  playTypeMatch,
  ageGroupMatch,
};
